/**
 * Command Center (report-dashboard) needs its own org-selection key for
 * superadmins, distinct from the shared `organization-context` key every
 * other REST/Apollo call reads for the `x-selected-organization` header -
 * reusing that shared key would mean picking an org here silently re-scopes
 * Voters search, Reports, and Absentee tools (which read it directly) for
 * the rest of the superadmin's session, with no visible indicator. Falls
 * back to the shared key so managers, whose dashboard scoping already comes
 * from the real OrganizationContext, are unaffected.
 */
export const COMMAND_CENTER_ORG_KEY = 'command-center-organization-context';

export const getDashboardOrgHeader = () =>
  localStorage.getItem(COMMAND_CENTER_ORG_KEY) || localStorage.getItem('organization-context');
